import { Sun, Moon, Monitor } from "lucide-react"
import { useThemeStore } from "@/store/themeStore"
import { cn } from "@/lib/utils"

const OPCIONES = [
  { v: "light", label: "Claro", Icon: Sun },
  { v: "dark", label: "Oscuro", Icon: Moon },
  { v: "system", label: "Sistema", Icon: Monitor },
] as const

/**
 * Claro / Oscuro / Sistema. Antes el portal solo alternaba claro↔oscuro desde un ícono, y quien
 * lo tocaba una vez ya no podía volver a seguir al tema del teléfono.
 */
export default function ThemePicker({ className, compacto = false }: { className?: string; compacto?: boolean }) {
  const theme = useThemeStore((s) => s.theme)
  const setTheme = useThemeStore((s) => s.setTheme)
  return (
    <div role="radiogroup" aria-label="Tema" className={cn("inline-flex w-full rounded-full border border-line bg-surface-muted p-0.5", className)}>
      {OPCIONES.map(({ v, label, Icon }) => {
        const activo = theme === v
        return (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={activo}
            onClick={() => setTheme(v)}
            className={cn(
              "flex flex-1 items-center justify-center gap-1.5 rounded-full px-2.5 h-8 text-caption font-medium transition-colors",
              activo ? "bg-card text-primary dark:text-primary-300 shadow-xs" : "text-subtle hover:text-foreground"
            )}
          >
            <Icon size={14} aria-hidden="true" />
            {!compacto && label}
            {compacto && <span className="sr-only">{label}</span>}
          </button>
        )
      })}
    </div>
  )
}
